const base_url = "https://api.contasalario.towty.com.br";
// const base_url = "http://127.0.0.1:3333";

export const URL_API = base_url;
